import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * Crypto API
 * Сервис для работы с оплатой криптовалютой (crypto1)
 */

export const fetchCryptoConfig = async () => {
  try {
    const response = await apiService.makeRequest('/api/crypto1/')

    if (response.crypto1) {
      return response.crypto1
    }

    throw new Error('Invalid response format: crypto1 config not found')
  } catch (error) {
    console.error('Error fetching Crypto config:', error)
    throw error
  }
}

export const fetchCryptoPackages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.crypto1 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching Crypto packages:', error)
    throw error
  }
}

export const createPaymentByDollars = async (dollars) => {
  try {
    const response = await apiService.makeRequest('/api/crypto1/', {
      method: 'POST',
      body: JSON.stringify({ dollar: dollars })
    })

    if (response.error) {
      if (response.error === 'error sum') throw new Error('INVALID_AMOUNT')
      if (response.error === 'error backend') throw new Error('BACKEND_ERROR')
      throw new Error(response.error)
    }

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating Crypto payment by dollars:', error)
    throw error
  }
}

export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/crypto1/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    if (response.error) {
      if (response.error === 'error sum') throw new Error('INVALID_AMOUNT')
      if (response.error === 'error backend') throw new Error('BACKEND_ERROR')
      throw new Error(response.error)
    }

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating Crypto payment by crystals:', error)
    throw error
  }
}

export const openCryptoPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'Crypto', paymentWindow)
}

export default {
  fetchCryptoConfig,
  fetchCryptoPackages,
  createPaymentByDollars,
  createPaymentByCrystals,
  openCryptoPayment
}
